import {
  DASHBOARD_INTENT_COLORS,
  hexToRgba,
} from "constants/dashboardIntentColors";

const SENTIMENT_META = {
  "1.0": {
    labelKey: "feedback_dropdown_values.2",
    fallback: "Positive",
    barValue: 100,
  },
  "1": {
    labelKey: "feedback_dropdown_values.2",
    fallback: "Positive",
    barValue: 100,
  },
  "0.5": {
    labelKey: "feedback_dropdown_values.3",
    fallback: "Neutral",
    barValue: 50,
  },
  "0.0": {
    labelKey: "feedback_dropdown_values.4",
    fallback: "Negative",
    barValue: 0,
  },
  "0": {
    labelKey: "feedback_dropdown_values.4",
    fallback: "Negative",
    barValue: 0,
  },
  "33": {
    labelKey: "feedback_dropdown_values.13",
    fallback: "Mixed",
    barValue: null,
  },
};

const INTENT_META = {
  "-1": { labelKey: "feedback_dropdown_values.1", icon: "/assets/Unspecified.svg" },
  "1": { labelKey: "feedback_dropdown_values.5", icon: "/assets/Appraisal.svg" },
  "2": { labelKey: "feedback_dropdown_values.6", icon: "/assets/Complaint.svg" },
  "3": { labelKey: "feedback_dropdown_values.7", icon: "/assets/Suggestion.svg" },
  "4": { labelKey: "feedback_dropdown_values.8", icon: "/assets/Remark.svg" },
  "5": {
    labelKey: "feedback_dropdown_values.9",
    icon: "/assets/Marketing & Spam.svg",
  },
  "6": { labelKey: "feedback_dropdown_values.10", icon: "/assets/Information.svg" },
  "7": { labelKey: "feedback_dropdown_values.11", icon: "/assets/Request.svg" },
  "8": { labelKey: "feedback_dropdown_values.12", icon: "/assets/Comparison.svg" },
  "33": { labelKey: "feedback_dropdown_values.13", icon: "/assets/mixed_intents.svg" },
};

const TOPIC_SENTIMENT_ICONS = {
  "-1": "/assets/Unspecified_Sentiment.svg",
  "1.0": "/assets/Positive.svg",
  "1": "/assets/Positive.svg",
  "0.5": "/assets/Neutral.svg",
  "0.0": "/assets/Negative.svg",
  "0": "/assets/Negative.svg",
  "33": "/assets/mixed_sentiments.svg",
};

function normalizeKey(value) {
  if (value == null || value === "") return null;
  const raw = String(value).trim();
  if (!raw) return null;
  if (raw === "33") return "33";
  const num = Number(raw);
  if (Number.isFinite(num)) {
    if (raw.includes(".")) {
      return Number.isInteger(num) ? num.toFixed(1) : String(num);
    }
    return String(parseInt(num, 10));
  }
  return raw;
}

export function buildDrawerOverallSentimentOptions(t) {
  return [
    {
      id: "33",
      value: "33",
      label: t("feedback_dropdown_values.13"),
      img: "/assets/mixed_sentiments.svg",
    },
    {
      id: "1.0",
      value: "1.0",
      label: t("feedback_dropdown_values.2"),
      img: "/assets/Positive.svg",
    },
    {
      id: "0.5",
      value: "0.5",
      label: t("feedback_dropdown_values.3"),
      img: "/assets/Neutral.svg",
    },
    {
      id: "0.0",
      value: "0.0",
      label: t("feedback_dropdown_values.4"),
      img: "/assets/Highly_negative.svg",
    },
  ];
}

export function buildDrawerOverallIntentOptions(t) {
  return [
    {
      id: "33",
      value: "33",
      label: t("feedback_dropdown_values.13"),
      img: "/assets/mixed_intents.svg",
    },
    {
      id: "1",
      value: "1",
      label: t("feedback_dropdown_values.5"),
      img: "/assets/Appraisal.svg",
    },
    {
      id: "2",
      value: "2",
      label: t("feedback_dropdown_values.6"),
      img: "/assets/Complaint.svg",
    },
    {
      id: "3",
      value: "3",
      label: t("feedback_dropdown_values.7"),
      img: "/assets/Suggestion.svg",
    },
    {
      id: "4",
      value: "4",
      label: t("feedback_dropdown_values.8"),
      img: "/assets/Remark.svg",
    },
    {
      id: "5",
      value: "5",
      label: t("feedback_dropdown_values.9"),
      img: "/assets/Marketing & Spam.svg",
    },
    {
      id: "6",
      value: "6",
      label: t("feedback_dropdown_values.10"),
      img: "/assets/Information.svg",
    },
    {
      id: "7",
      value: "7",
      label: t("feedback_dropdown_values.11"),
      img: "/assets/Request.svg",
    },
    {
      id: "8",
      value: "8",
      label: t("feedback_dropdown_values.12"),
      img: "/assets/Comparison.svg",
    },
  ];
}

export function buildDrawerTopicSentimentOptions(t) {
  return [
    {
      id: "-1",
      value: "-1",
      label: t("feedback_dropdown_values.1"),
      img: "/assets/Unspecified_Sentiment.svg",
    },
    {
      id: "1.0",
      value: "1.0",
      label: t("feedback_dropdown_values.2"),
      img: "/assets/Positive.svg",
    },
    {
      id: "0.5",
      value: "0.5",
      label: t("feedback_dropdown_values.3"),
      img: "/assets/Neutral.svg",
    },
    {
      id: "0.0",
      value: "0.0",
      label: t("feedback_dropdown_values.4"),
      img: "/assets/Negative.svg",
    },
  ];
}

export function findDrawerSelectOption(options, key) {
  if (key == null || key === "" || !Array.isArray(options)) return null;
  const normalized = normalizeKey(key);
  const asNum = Number(key);
  return (
    options.find((opt) => {
      if (opt.id === key || opt.value === key) return true;
      if (
        normalized &&
        (String(opt.id) === normalized || String(opt.value) === normalized)
      ) {
        return true;
      }
      return (
        Number.isFinite(asNum) &&
        (Number(opt.id) === asNum || Number(opt.value) === asNum)
      );
    }) || null
  );
}

export function resolveDrawerSentimentMeta(review) {
  const key = normalizeKey(review?.drawer_sentiment ?? review?.num_sentiment);
  if (!key) return null;
  const meta = SENTIMENT_META[key] || SENTIMENT_META[String(Number(key))];
  if (!meta) return { key, barValue: null };
  return { key, ...meta };
}

export function resolveDrawerIntentMeta(review) {
  const key = normalizeKey(review?.drawer_intent ?? review?.num_intent);
  if (!key) return null;
  const meta = INTENT_META[key];
  const hex = DASHBOARD_INTENT_COLORS[key] || DASHBOARD_INTENT_COLORS["-1"];
  return {
    key,
    icon: meta?.icon || "/assets/Unspecified.svg",
    labelKey: meta?.labelKey,
    color: hex,
    background: hexToRgba(hex, 0.14),
  };
}

export function resolveDrawerDecisionTags(review) {
  const tags = review?.drawer_decision_tags;
  return Array.isArray(tags) ? tags.filter(Boolean) : [];
}

export function resolveDrawerTopicTags(review) {
  const fromApi = review?.drawer_topic_tags;
  if (Array.isArray(fromApi) && fromApi.length) {
    return fromApi.filter((tag) => tag?.label);
  }
  const associated = review?.associated_topics;
  if (!Array.isArray(associated)) return [];
  return associated
    .filter((tag) => tag?.label)
    .map((tag) => ({
      id: tag.id,
      label: tag.label,
      type: tag.type || "custom",
      sentiment: null,
      intent: null,
    }));
}

export function resolveTopicTagSentimentIcon(key) {
  const normalized = normalizeKey(key);
  if (!normalized) return TOPIC_SENTIMENT_ICONS["-1"];
  return TOPIC_SENTIMENT_ICONS[normalized] || TOPIC_SENTIMENT_ICONS["-1"];
}

export function resolveTopicTagIntentIcon(key) {
  const normalized = normalizeKey(key);
  if (!normalized) return "/assets/Unspecified.svg";
  return INTENT_META[normalized]?.icon || "/assets/Unspecified.svg";
}

export function resolveTopicTagColors(topicType, theme) {
  if (topicType === "ai") {
    return {
      background: "rgba(215, 183, 124, 0.945)",
      color: theme === "dark" ? "#754d03" : "#bd7b01",
    };
  }
  return {
    background: "rgba(185, 157, 255, 0.3)",
    color: theme === "dark" ? "rgb(185, 167, 230)" : "rgb(101, 77, 163)",
  };
}

const SENTIMENT_MARK_NEUTRAL = "#FFC223";

/** Same palette as dashboard ReviewItem text marks. */
export function resolveSentimentMarkColor(sentiment) {
  if (String(sentiment) === "33") return "#FB6542";
  const n = parseFloat(sentiment);
  if (Number.isFinite(n) && n > 0.5 && n <= 1) return "#369E3A";
  if (n === 0.5) return SENTIMENT_MARK_NEUTRAL;
  if (Number.isFinite(n) && n >= 0 && n < 0.5) return "#FF1D1D";
  return "#858585";
}

/** Build topic id → [[start, end], …] from review sequences (dashboard ReviewItem parity). */
export function buildDrawerTopicHighlightIndex(sequences) {
  if (!Array.isArray(sequences) || sequences.length === 0) {
    return {};
  }
  const index = {};
  sequences.forEach((sequence) => {
    const startIndex = parseInt(sequence?.start_index, 10);
    const endIndex = parseInt(sequence?.end_index, 10);
    if (!Number.isFinite(startIndex) || !Number.isFinite(endIndex)) {
      return;
    }
    const associations = sequence?.topic_associations;
    if (!Array.isArray(associations)) return;
    associations.forEach((topic) => {
      if (topic?.id == null) return;
      const key = String(topic.id);
      if (!index[key]) index[key] = [];
      index[key].push([startIndex, endIndex]);
    });
  });
  return index;
}

function mergeHighlightRanges(ranges) {
  if (!ranges?.length) return [];
  const sorted = [...ranges]
    .map(([start, end]) => [Math.min(start, end), Math.max(start, end)])
    .sort((a, b) => a[0] - b[0]);
  const merged = [sorted[0]];
  for (let i = 1; i < sorted.length; i += 1) {
    const prev = merged[merged.length - 1];
    const curr = sorted[i];
    if (curr[0] <= prev[1] + 1) {
      prev[1] = Math.max(prev[1], curr[1]);
    } else {
      merged.push(curr);
    }
  }
  return merged;
}

/** Fallback when sequences are missing: match leaf topic label in review text. */
export function findDrawerTopicLabelRanges(text, label) {
  const source = String(text ?? "");
  const leaf = String(label ?? "")
    .split(">")
    .pop()
    ?.trim();
  if (!source || !leaf || leaf.length < 2) return [];

  const lowerText = source.toLocaleLowerCase("tr");
  const lowerNeedle = leaf.toLocaleLowerCase("tr");
  const ranges = [];
  let cursor = 0;
  while (cursor < lowerText.length) {
    const found = lowerText.indexOf(lowerNeedle, cursor);
    if (found === -1) break;
    ranges.push([found, found + lowerNeedle.length - 1]);
    cursor = found + lowerNeedle.length;
  }
  return ranges;
}

export function resolveDrawerTopicHighlightRanges(topic, text, topicIndex) {
  const topicKey = topic?.id != null ? String(topic.id) : "";
  const fromSequences = topicKey ? topicIndex?.[topicKey] : null;
  if (Array.isArray(fromSequences) && fromSequences.length) {
    return mergeHighlightRanges(fromSequences);
  }
  return [];
}

const EMPTY_CLASSIFIER_INDICES = {
  Publish: [],
  "Do not Publish": [],
  "Open a case": [],
  "Do not open a case": [],
  "Take action": [],
  "Do not take action": [],
};

/** Build topic/classifier index maps from highlight sequences (ReviewItem parity). */
export function buildDrawerSequenceMeta(sequences) {
  if (!Array.isArray(sequences) || sequences.length === 0) {
    return {
      topicIndices: {},
      indicesSentiment: {},
      topicSentiments: {},
      topicIntents: {},
    };
  }

  const indicesSentiment = {};
  const topicIndices = {};
  const topicSentiments = {};
  const topicIntents = {};
  const tpcSent = {};
  const tpcIntnt = {};

  sequences.forEach((sequence) => {
    const startIndex = parseInt(sequence?.start_index, 10);
    const endIndex = parseInt(sequence?.end_index, 10);
    if (!Number.isFinite(startIndex) || !Number.isFinite(endIndex)) return;

    const associations = sequence?.topic_associations;
    if (!Array.isArray(associations)) return;

    const date = sequence?.date ? new Date(sequence.date) : null;

    associations.forEach((topic) => {
      const topicId = topic?.id;
      if (topicId == null) return;

      const sentiment = topic.sentiment;
      const intent = topic.intent;
      indicesSentiment[`${startIndex}, ${endIndex}`] = sentiment;

      if (!topicIndices[topicId]) topicIndices[topicId] = [];
      topicIndices[topicId].push([startIndex, endIndex]);

      if (date && !Number.isNaN(date.getTime())) {
        if (!tpcSent[topicId] || date > new Date(tpcSent[topicId].date)) {
          tpcSent[topicId] = { sentiment, date };
        }
        if (!tpcIntnt[topicId] || date > new Date(tpcIntnt[topicId].date)) {
          tpcIntnt[topicId] = { intent, date };
        }
      } else {
        if (sentiment != null && topicSentiments[topicId] == null) {
          topicSentiments[topicId] = sentiment;
        }
        if (intent != null && topicIntents[topicId] == null) {
          topicIntents[topicId] = intent;
        }
      }
    });
  });

  for (const topicId of Object.keys(tpcSent)) {
    topicSentiments[topicId] = tpcSent[topicId].sentiment;
  }
  for (const topicId of Object.keys(tpcIntnt)) {
    topicIntents[topicId] = tpcIntnt[topicId].intent;
  }

  return { topicIndices, indicesSentiment, topicSentiments, topicIntents };
}

export function buildDrawerClassifierMeta(classifierSequences) {
  if (!Array.isArray(classifierSequences) || classifierSequences.length === 0) {
    return {
      classifierIndices: { ...EMPTY_CLASSIFIER_INDICES },
      decisionTags: [],
    };
  }

  const classifierIndices = {
    Publish: [],
    "Do not Publish": [],
    "Open a case": [],
    "Do not open a case": [],
    "Take action": [],
    "Do not take action": [],
  };

  classifierSequences.forEach((sequence) => {
    const startIndex = parseInt(sequence?.start_index, 10);
    const endIndex = parseInt(sequence?.end_index, 10);
    if (!Number.isFinite(startIndex) || !Number.isFinite(endIndex)) return;

    const indices = [startIndex, endIndex];
    const classifier = sequence?.classifier;
    if (!classifier) return;

    if (classifier.mPublish === true) {
      classifierIndices.Publish.push(indices);
    } else if (classifier.mPublish === false) {
      classifierIndices["Do not Publish"].push(indices);
    }
    if (classifier.mOpenCase === true) {
      classifierIndices["Open a case"].push(indices);
    } else if (classifier.mOpenCase === false) {
      classifierIndices["Do not open a case"].push(indices);
    }
    if (classifier.mAction === true) {
      classifierIndices["Take action"].push(indices);
    } else if (classifier.mAction === false) {
      classifierIndices["Do not take action"].push(indices);
    }
  });

  const dTags = [];
  const publishSet = new Set();
  const caseSet = new Set();
  const actionSet = new Set();

  classifierSequences.forEach((seq) => {
    if (seq?.classifier) {
      publishSet.add(seq.classifier.mPublish);
      caseSet.add(seq.classifier.mOpenCase);
      actionSet.add(seq.classifier.mAction);
    }
  });

  if (publishSet.has(true)) dTags.push("Publish");
  if (publishSet.has(false)) dTags.push("Do not Publish");
  if (caseSet.has(true)) dTags.push("Open a case");
  if (caseSet.has(false)) dTags.push("Do not open a case");
  if (actionSet.has(true)) dTags.push("Take action");
  if (actionSet.has(false)) dTags.push("Do not take action");

  return { classifierIndices, decisionTags: dTags };
}

export function resolveDrawerTopicTagsFromHighlight(
  associatedTopics,
  topicSentiments,
  topicIntents,
) {
  if (!Array.isArray(associatedTopics)) return [];
  return associatedTopics
    .filter((tag) => tag?.label)
    .map((tag) => ({
      id: tag.id,
      label: tag.label,
      type: tag.type || "custom",
      sentiment: topicSentiments?.[tag.id] ?? null,
      intent: topicIntents?.[tag.id] ?? null,
    }));
}
